export default __webpack_public_path__ + "static/media/booking-summary.0dffbfd7.jpg";